import { DateTime } from 'luxon';

export const DEFAULT_FORMAT = 'yyyy-MM-dd';

/**
 * Returns yesterday's date
 * @example getYesterdaysDate(); // "2000-01-01"
 * @param format - format to return
 */
export const getYesterdaysDate = (format?: string) =>
  DateTime.local()
    .minus({ days: 1 })
    .toFormat(format || DEFAULT_FORMAT);

/**
 * Returns today's date minus "X" days
 * @example getXMinusDate(4); // "2000-01-01"
 * @param minus - number of days to minus from today
 * @param format - format to return
 */
export const getXMinusTodaysDate = (minus: number, format?: string) =>
  DateTime.local()
    .minus({ days: minus })
    .toFormat(format || DEFAULT_FORMAT);

/**
 * Returns a date well into the past of a catalog's history to represent
 * a full catalog export
 * @example getEarliestStartDate(); // "1900-01-01"
 * @param format - format to return
 */
export const getEarliestStartDate = (format?: string) =>
  DateTime.local(1900, 1, 1).toFormat(format || DEFAULT_FORMAT);
